export default "__VITE_ASSET__DEqrsQcZ__"